import CustomError from '../CustomError';

class ForbiddenError extends CustomError {
  static type = 'ChunkLoadError';

  constructor(message?: string) {
    super(message);
    this._type = ForbiddenError.type;
  }
}

export default ForbiddenError;
